<template>
  <section id="buy-now-pay-later-panel">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="page-inner">
      <div class="content-panel">
        <buy-now-pay-later-title @get-buy-now-pay-later="getBuyNowPayLater" />

        <b-tabs
          position="is-centered"
          class="block"
          size="is-large"
          expanded
          @input="changeTabsStyle"
        >
          <b-tab-item :label="$t('buyNowPayLater.transactions')">
            <h2 v-if="Object.keys(bills).length === 0" class="empty-state">
              {{ $t("buyNowPayLater.noBuyNowPayLaterTransactionsAtThisTime") }}
            </h2>

            <div v-else>
              <div v-for="(bill, i) in bills" :key="i">
                <div class="bill-header">
                  <div class="bill-header-col">
                    <p>
                      <b>{{ $t("buyNowPayLater.store") }}:</b>
                      {{ bill.store.storeInfo.name }}
                    </p>
                    <p>
                      <b>{{ $t("buyNowPayLater.totalBilletValue") }}:</b>
                      {{ `R$${formatMoney(bill.totalBilletvalue)}` }}
                    </p>
                  </div>
                </div>

                <buy-now-pay-later-table :transactions="bill.transactions" />

                <hr class="separator" />
              </div>
            </div>
          </b-tab-item>

          <b-tab-item :label="$t('buyNowPayLater.billets')">
            <billets-table :billets="billetsReverse" />
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";
import buyNowPayLaterTitle from "./BuyNowPayLaterTitle";
import buyNowPayLaterTable from "./BuyNowPayLaterTable";
import billetsTable from "./BilletsTable";

export default {
  mixins: [common, mask],

  components: {
    buyNowPayLaterTitle,
    buyNowPayLaterTable,
    billetsTable
  },

  data() {
    return {
      isLoading: false,
      stores: [],
      partners: [],
      bills: {}
    };
  },

  computed: {
    ...mapGetters(["buyNowPayLaterTransactionsReverse", "billetsReverse"])
  },

  methods: {
    getBuyNowPayLater() {
      this.isLoading = true;
      this.$store
        .dispatch("getBuyNowPayLater")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.stores = res.data.payload.stores;
            this.partners = res.data.payload.partners;
            this.mountBills();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    changeTabsStyle(tabId) {
      const tabsQty =
        document.getElementsByClassName("tabs")[0].children[0].children.length;

      let tab;
      for (let i = 0; i < tabsQty; i++) {
        tab =
          document.getElementsByClassName("tabs")[0].children[0].children[i];

        if (tab.children[0].id === `${tabId}-label`) {
          tab.children[0].style.setProperty(
            "border-bottom-color",
            "#f0512d",
            "important"
          );
          tab.children[0].style.setProperty("color", "#f0512d", "important");
        } else {
          tab.children[0].style.setProperty(
            "border-bottom-color",
            "rgb(219, 219, 219)",
            "important"
          );
          tab.children[0].style.setProperty("color", "#4A4A4A", "important");
        }
      }
    },

    mountBills() {
      this.bills = {};
      for (let i = 0; i < this.buyNowPayLaterTransactionsReverse.length; i++) {
        const t = this.buyNowPayLaterTransactionsReverse[i];
        const key = `s-${t.store._id}`;

        if (!Object.prototype.hasOwnProperty.call(this.bills, key)) {
          const storeIndex = this.stores.findIndex(s => s._id === t.store._id);
          this.bills[key] = {
            store: this.stores[storeIndex],
            transactions: [t],
            totalBilletvalue: t.details.paymentMethodValue
          };
        } else {
          this.bills[key].transactions.push(t);
          this.bills[key].totalBilletvalue += t.details.paymentMethodValue;
        }
      }
    }
  },

  mounted() {
    this.getBuyNowPayLater();

    this.$nextTick(() => {
      const tab1 =
        document.getElementsByClassName("tabs")[0].children[0].children[0];
      tab1.children[0].style.setProperty("color", "#f0512d", "important");
      tab1.children[0].style.setProperty(
        "border-bottom-color",
        "#f0512d",
        "important"
      );

      const tabsQty =
        document.getElementsByClassName("tabs")[0].children[0].children.length;
      for (let i = 1; i < tabsQty; i++) {
        document
          .getElementsByClassName("tabs")[0]
          .children[0].children[i].children[0].style.setProperty(
            "color",
            "#4A4A4A",
            "important"
          );
      }
    });
  }
};
</script>

<style scoped>
#buy-now-pay-later-panel {
  min-height: 100vh;
  background-color: #f8f7fa;
  padding: 1.5rem;
}

.page-inner {
  width: 100%;
}

.content-panel {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #f3f4f6;
  padding: 1.5rem;
}

.empty-state {
  padding: 3rem 0;
  color: #9ca3af;
  text-align: center;
  font-size: 0.95rem;
}

.bill-header {
  margin: 1rem 0;
}

.bill-header-col p {
  margin-bottom: 0.25rem;
}

.separator {
  background-color: #e5e5e5;
}
</style>
